<template>
  <form>
    <div class="category-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="cancelOption">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="!isNew()" @click.prevent="handleDeleteOption" style="padding: 7px 10px; margin-right: 20px;margin-bottom: 0;">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-icon btn-success mar-rt-10 save" style="margin-bottom: 0;"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>

    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch;">

      <div class="col-lg-12 col-md-8 col-sm-8">
        <div class="card">
          <div class="card-content">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <label for="option_name">
                      Name:
                      <input type="text" id="option_name" class="form-control" v-model="option_name">
                    </label>
                  </div>
                </div>
                <br>
                <div class="prod-tabs" direction="horizontal" type="tabs">
                  <div class="col-md-12 display-flex align-items-center justify-content-space-between">
                    <h6>{{$t('catalogProdOpt.plural')}}</h6>
                    <button class="btn add mar-to-15 mar-lt-20 "
                            v-if="model && Object.keys(companyOptions).length > model.length"
                            @click.prevent="addNewOption()"
                            :title="$t('general.add')  + ' ' + $t('catalogProdOpt.single')" >
                            <img src="/static/img/icons/add.png">
                            {{$t('general.add')}}
                    </button>
                  </div>
                  <div class="col-md-12 pad-lf-0 pad-rg-0">
                    <hr class="sm" style="margin-bottom: 5px;">
                  </div>
                  <div :title="$t('catalogProdOpt.plural')" class="text-left">
                    <div class="row">

                      <div class="col-md-12 pad-to-10" style="padding-top: 0px;" >
                        <!-- <p v-if="model.product_options.length == 0" class="">No options added yet.</p> -->
                        <el-collapse ref="elColl" v-model="tabIndex" accordion>
                          <template v-for="(option, idxO) in model">
                            <button class="btn btn-danger pull-left btn-icon mar-15" :title="$t('general.delete')" @click.prevent="deleteOption(idxO)"><i class="ti-close"></i></button>
                            <el-collapse-item :title="option.company_option && option.company_option.label ? option.name + ' (' + option.company_option.label + ')' : option.name" :name="idxO">
                              <div class="clearfix"><hr class="no-margin mar-bt-15" /></div>
                              <div class="row">
                                <div class="col-md-6">
                                  <div class="form-group pad-to-10">
                                    <label>{{$t('catalogProdOpt.single')}}</label>
                                    <select class="form-control"
                                            v-model="model[idxO].company_option_id"
                                            @change="changeOption(idxO, model[idxO].company_option_id)"
                                            placeholder="Pick an option"
                                            v-validate="{required: true}"
                                            >
                                      <option disabled value="null">{{$t('catalogProd.pickAnOption')}}</option>
                                      <template v-for="prOption in companyOptions">
                                        <option :value="prOption.id"
                                                :disabled="disableOption(idxO, prOption.id, true) && model[idxO].company_option_id != prOption.id"
                                        >{{ prOption.name }} {{ prOption.label && prOption.label.length ? '(' + prOption.label + ')' : ''}}</option>
                                      </template>
                                    </select>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group pad-to-10">
                                    <label>{{$t('general.required')}}</label>
                                    <select class="form-control" v-model="option.required">
                                      <option :value="true">{{$t('general.yes')}}</option>
                                      <option :value="false">{{$t('general.no')}}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label>{{$t('productOptions.hidePrices')}}</label>
                                    <select class="form-control" v-model="option.hide_prices">
                                      <option :value="true">{{$t('general.yes')}}</option>
                                      <option :value="false">{{$t('general.no')}}</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label>{{$t('productOptions.hasDefaultValue')}}</label>
                                    <select class="form-control" v-model="option.has_default_value">
                                      <option :value="true">{{$t('general.yes')}}</option>
                                      <option :value="false">{{$t('general.no')}}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6" v-if="option.type == 'checkbox' || option.type == 'upload'">
                                  <div class="form-group">
                                    <label>{{$t('catalogProd.minNoSelected')}}</label>
                                    <input type="number" @change="validateOption(option, model[idxO].company_option_id)" class="form-control" name="min" v-model="option.min_no" />
                                    <small class="text-danger" v-if="errors.has('min' + model[idxO].company_option_id)">
                                      {{ getError('min' + model[idxO].company_option_id) }}
                                    </small>
                                    <small class="text-danger" v-if="errors.has('min_negative' + model[idxO].company_option_id)">
                                      {{ getError('min_negative' + model[idxO].company_option_id) }}
                                    </small>
                                  </div>
                                </div>
                                <div class="col-md-6" v-if="option.type == 'checkbox' || option.type == 'upload'">
                                  <div class="form-group">
                                    <label>{{$t('catalogProd.maxNoSelected')}}</label>
                                    <input type="number" @change="validateOption(option, model[idxO].company_option_id)" class="form-control" name="max" v-model="option.max_no" />
                                    <small class="text-danger" v-if="errors.has('max' + model[idxO].company_option_id)">
                                      {{ getError('max' + model[idxO].company_option_id) }}
                                    </small>
                                    <small class="text-danger" v-if="errors.has('max_negative' + model[idxO].company_option_id)">
                                      {{ getError('max_negative' + model[idxO].company_option_id) }}
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <table class="table no-margin" v-if="option.id != ''">
                                <thead>
                                  <tr>
                                    <th style="min-width: 200px">{{$t('catalogProd.optVal')}}</th>
                                    <th>{{$t('catalogProd.price')}} ({{currency}})
                                    </th>
                                    <th>Pos Id</th>
                                    <th v-if="use_pos_id_per_product_option">Pos Id 2</th>
                                    <th v-if="use_quantity_per_product_option">Qty.</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(value, idx) in option.group_company_option_values">
                                    <td>
                                      <template v-if="companyOptions[getObjectByElemKeyValue('id', option.company_option_id, companyOptions)]">
                                        <el-select class="group-option-value-select"
                                                   v-model="value.company_option_value_id"
                                                   filterable
                                                   :filter-method="filterOptionValues"
                                                   @visible-change="resetOptionValueQuery"
                                                   :placeholder="$t('catalogProd.pickAnOption')"
                                                   @change="selectOptionValue($event, idxO, idx)"
                                                   v-validate="{required: true}">
                                          <el-option v-for="prOption in companyOptions[getObjectByElemKeyValue('id', option.company_option_id, companyOptions)]['values']"
                                                     v-if="matchesOptionValueQuery(prOption.name, value.company_option_value_id, prOption.id)"
                                                     :key="prOption.id"
                                                     :label="prOption.name"
                                                     :value="prOption.id"
                                                     :disabled="disableOption(idxO, prOption.id, false) && value.company_option_value_id != prOption.id">
                                          </el-option>
                                        </el-select>
                                      </template>
                                    </td>
                                    <td>
                                      <div class="row">
                                        <div class="col-md-12">
                                          <input type="number"
                                                  v-validate="{min_value: 0}"
                                                  class="form-control"
                                                  v-model="value.price">
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div class="row">
                                        <div class="col-md-12">
                                          <input type="text"
                                                  class="form-control"
                                                  v-model="value.pos_id">
                                        </div>
                                      </div>
                                    </td>
                                    <td v-if="use_pos_id_per_product_option || (value.hasOwnProperty('pos_id_per_product') && value.pos_id_per_product) ">
                                      <div class="row">
                                        <div class="col-md-12">
                                          <input type="text"
                                                  class="form-control"
                                                  v-model="value.pos_id_per_product">
                                        </div>
                                      </div>
                                    </td>
                                    <td v-if="use_quantity_per_product_option || (value.hasOwnProperty('quantity_per_option') && value.quantity_per_option) ">
                                      <div class="row">
                                        <div class="col-md-12">
                                          <input type="text"
                                                  class="form-control"
                                                  v-model="value.quantity_per_option">
                                        </div>
                                      </div>
                                    </td>
                                    <td><button class="btn btn-simple btn-icon " @click.prevent="deleteOptionValue(idxO, idx)"><i :title="$t('general.delete')" class="ti-close text-danger"></i></button></td>
                                  </tr>

                                </tbody>
                              </table>
                              <div class="pull-right" v-if="1">
                              <!-- <div class="pull-right" v-if="showAddButton(idxO, option)"> -->
                                <button title="" @click="validateOption(option, model[idxO].company_option_id)" class="btn add mar-to-15 mar-lt-20" @click.prevent="addNewOptionValue(idxO)">
                                    <img src="/static/img/icons/add.png">
                                    {{$t('general.add')}} {{$t('catalogProdOpt.single')}} {{$t('catalogProdOpt.value')}}
                                </button>
                              </div>
                            </el-collapse-item>
                          </template>
                        </el-collapse>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-4 col-sm-4" v-if="!isNew()">
        <div class="card">
          <div class="card-content">
            <div class="row">
              <div class="col-md-12">
                <label for="option_name">
                  <p>{{this.$t('groupOption.importTitle')}}</p>
                  <br>
                  <label for="location_token">{{this.$t('pages.categories')}}</label>
                  <select name="category_id"
                                class="form-control"
                                data-vv-as="category"
                                ref="category_id"
                                v-model="selectedCategoryForImport"
                  >
                    <option :value="null" label="Select"> </option>
                    <option v-for="option in mainCategories"
                               :value="option.id"
                               :label="option.name"
                               :key="option.id">
                    </option>
                  </select>
                  <br>
                  <label for="location_token">{{this.$t('settingsOrdering.locations')}}</label>
                  <select name="location_token"
                          id="location_token"
                          class="form-control"
                          data-vv-as="location"
                          ref="location_token"
                          v-model="selectedLocationForImport"
                    >
                    <option :value="null" :label="this.$t('general.all')"></option>
                    <option v-for="el in locations"
                               :value="el.token"
                               :label="el.name"
                               :key="el.id">
                    </option>
                  </select>
                  <br>
                  <button class="btn add mar-to-15" @click.prevent="importGroupOptionToCategory()">
                    <img src="/static/img/icons/add.png">
                    {{$t('general.add')}}
                  </button>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="space_for_alert_box" style="height: 100px; width: 100%;"></div>
  </form>
</template>
<script>
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, Select, Option} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import swal from 'sweetalert2'
  import draggable from 'vuedraggable'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)

  export default {
    components: {
      PSwitch,
      draggable,
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      },
      groupId: null,
      callback: {
        required: false
      }
    },
    watch: {
      groupId (value) {
        this.id = value
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      // let companyData = this.$session.get('selectedCompanyData')
      this.getData()
      this.getCategorys()
      this.getLocations()
    },
    data () {
      return {
        apiUrl: '',
        id: this.value || this.groupId,
        model: false,
        option_name: '',
        tabIndex: null,
        modelValidate: {
          name: {required: true},
          type: {required: true},
          status: {required: true}
        },
        companyOptions: [],
        mainCategories: [],
        locations: [],
        selectedCategoryForImport: null,
        selectedLocationForImport: null,
        validateOptionCheck: true,
        languages: this.$session.get('defaultData')['available_languages'],
        currency: this.$session.get('selectedCompanyData')['currency_iso'],
        use_pos_id_per_product_option: this.$session.get('selectedCompanyData')['use_pos_id_per_product_option'] || 0,
        use_quantity_per_product_option: this.$session.get('selectedCompanyData')['use_quantity_per_product_option'] || 0,
        deleteOptionValues: [],
        deleteOptions: [],
        optionValueQuery: '',
        loading: true
      }
    },
    methods: {
      getData () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        if (!this.isNew()) {
          var id = this.route.params.id || this.id
          this.apiRequest('/group-options/' + id, 'GET', data, (response) => {
            if (response.status === true) {
              this.option_name = response.data.group_option.name
              this.model = response.data.group_option.options
              this.companyOptions = response.data.company_options
              // this.model.image = [{'url': this.model.image}]
              // this.model.prod_image = [{'url': this.model.prod_image}]
              this.loading = false
            }
          })
        } else {
          this.model = [
          // {
          //   'id': null,
          //   'active': true,
          //   'image': [],
          //   'prod_image': [],
          //   'location_ids': '',
          //   'type': 'checkbox',
          //   'name': '',
          //   'group_company_option_values': []
          // }
          ]
          this.apiRequest('/get-company-options/', 'GET', data, (response) => {
            if (response.status === true) {
              this.companyOptions = response.data.options
              this.loading = false
            }
          })
        }
      },
      getCategorys () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          inactive: 1
        }
        this.apiRequest('/category', 'GET', data, (response) => {
          if (response.status === true) {
            this.mainCategories = response.data
          }
        })
      },
      getLocations () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/get-locations', 'GET', data, (response) => {
          if (response.status === true) {
            this.locations = response.data
          }
        })
      },
      importGroupOptionToCategory () {
        if (this.selectedCategoryForImport) {
          swal({
            text: this.$t('groupOption.areYouSure'),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: this.$t('general.yes')
          })
          .then((result) => {
            if (result) {
              var data = {
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany'),
                group_id: this.route.params.id,
                category_id: this.selectedCategoryForImport
              }
              if (this.selectedLocationForImport) {
                data.location_token = this.selectedLocationForImport
              }
              this.apiRequest('/import-group-options', 'POST', data, (response) => {
                if (response.status === true) {
                  swal({'text': 'success', 'type': 'success', 'showConfirmButton': false, 'timer': 1000}).catch(() => {})
                } else {
                  swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 1000}).catch(() => {})
                }
              })
            }
          })
        }
        return false
      },
      isNew () {
        if (this.route.params.id) {
          return false
        } else {
          return true
        }
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveOption() }
        })
      },
      validateOption (option, keyId) {
        this.validateOptionCheck = true
        if (option.group_company_option_values.length && option.max_no > parseInt(option.group_company_option_values.length)) {
          this.errors.add('max' + keyId, this.$t('catalogProd.maxNoTooHigh'))
          this.validateOptionCheck = false
        } else {
          if (this.errors.items.length) {
            this.errors.items = this.errors.items.filter(item => item.field !== 'max' + keyId)
          }
        }

        if (parseInt(option.min_no) > parseInt(option.max_no) && parseInt(option.max_no)) {
          this.errors.add('min' + keyId, this.$t('catalogProd.minNoTooHigh'))
          this.validateOptionCheck = false
        } else {
          if (this.errors.items.length) {
            this.errors.items = this.errors.items.filter(item => item.field !== 'min' + keyId)
          }
        }

        if (parseInt(option.min_no) < 0) {
          this.errors.add('min_negative' + keyId, this.$t('catalogProd.minNoNegative'))
          this.validateOptionCheck = false
        } else {
          if (this.errors.items.length) {
            this.errors.items = this.errors.items.filter(item => item.field !== 'min_negative' + keyId)
          }
        }

        if (parseInt(option.max_no) < 0) {
          this.errors.add('max_negative' + keyId, this.$t('catalogProd.maxNoNegative'))
          this.validateOptionCheck = false
        } else {
          if (this.errors.items.length) {
            this.errors.items = this.errors.items.filter(item => item.field !== 'max_negative' + keyId)
          }
        }
      },
      selectOptionValue (selectedId, optionIndex, optionValueIndex) {
        const option = this.model[optionIndex]
        const companyOptionIndex = this.getObjectByElemKeyValue('id', option.company_option_id, this.companyOptions)
        let selectedName = ''
        if (companyOptionIndex !== false && this.companyOptions[companyOptionIndex] && this.companyOptions[companyOptionIndex]['values']) {
          const values = this.companyOptions[companyOptionIndex]['values']
          const valueIndex = this.getObjectByElemKeyValue('id', selectedId, values)
          if (valueIndex !== false && values[valueIndex]) {
            selectedName = values[valueIndex].name
          }
        }
        Vue.set(this.model[optionIndex].group_company_option_values[optionValueIndex], 'company_option_value_id', selectedId)
        Vue.set(this.model[optionIndex].group_company_option_values[optionValueIndex], 'name', selectedName)
      },
      removeDiacritics (str) {
        return String(str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      },
      filterOptionValues (query) {
        this.optionValueQuery = query
      },
      resetOptionValueQuery (visible) {
        if (visible) {
          this.optionValueQuery = ''
        }
      },
      matchesOptionValueQuery (name, selectedId, optionId) {
        if (optionId === selectedId) {
          return true
        }
        const query = this.removeDiacritics(this.optionValueQuery).toLowerCase().trim()
        if (!query) {
          return true
        }
        return this.removeDiacritics(name).toLowerCase().indexOf(query) > -1
      },
      handleErrors (errors) {
        swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
      },
      handleDeleteOption () {
        let self = this
        swal({
          text: self.$t('catalogProdOpt.areyouSure'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            self.trueDeleteOption()
          }
        })
      },
      trueDeleteOption () {
        let data = {}
        let id = this.route.params.id
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')
        data.delete = 1
        this.apiRequest('/group-options/' + id, 'PUT', data, (response) => {
          if (response.status === true) {
            this.trackAdminEvent('ADMIN_OPTION_GROUP_DELETED', 'option_group', id, {
              option_group_id: id,
              name: this.option_name || null
            })
            this.cancelOption()
          }
        })
      },
      saveOption () {
        this.loading = true
        let id = this.route.params.id || 0
        let data = {}
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')
        data.option_name = this.option_name
        data.option = this.model
        data.deleteOptions = this.deleteOptions
        data.deleteOptionValues = this.deleteOptionValues

        // Ensure pos_id is present for all group_company_option_values before saving
        if (Array.isArray(data.option)) {
          data.option.forEach(opt => {
            if (opt && Array.isArray(opt.group_company_option_values)) {
              opt.group_company_option_values.forEach(val => {
                if (val && (val.pos_id === undefined || val.pos_id === null)) {
                  val.pos_id = ''
                }
              })
            }

            // Some API payloads/endpoints use `values` instead of `group_company_option_values`.
            // Keep them in sync so pos_id is not lost.
            if (opt && Array.isArray(opt.values) && Array.isArray(opt.group_company_option_values)) {
              opt.values.forEach(v => {
                const match = opt.group_company_option_values.find(gv => (
                  (gv.id && v.id && gv.id === v.id) ||
                  (gv.company_option_value_id && v.company_option_value_id && gv.company_option_value_id === v.company_option_value_id)
                ))
                if (match && (v.pos_id === undefined || v.pos_id === null)) {
                  v.pos_id = match.pos_id
                }
              })
            } else if (opt && !opt.values && Array.isArray(opt.group_company_option_values)) {
              opt.values = opt.group_company_option_values
            }
          })
        }

        this.apiRequest('/group-options/' + id, 'PUT', data, (response) => {
          if (response.status === true) {
            this.loading = false
            this.errors.clear()
            swal({'text': this.$t('menuLink.updated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            this.cancelOption()
          } else {
            this.loading = false
            this.handleErrors(response.errors)
          }
        })
      },
      deleteOption (thisOptIdx) {
        swal({
          text: this.$t('catalogProdOpt.areyouSure'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            if (this.model[thisOptIdx].id) {
              this.deleteOptions.push(this.model[thisOptIdx].id)
            }
            this.model.splice(thisOptIdx, 1)
          }
        })
      },
      deleteOptionValue (thisOptIdx, thisValIdx) {
        if (this.model[thisOptIdx].group_company_option_values[thisValIdx].id) {
          this.deleteOptionValues.push(this.model[thisOptIdx].group_company_option_values[thisValIdx].id)
        }
        this.model[thisOptIdx].group_company_option_values.splice(thisValIdx, 1)
      },
      addNewOption () {
        // 'type': 'radiobox',
        // 'name': '',
        // 'modified': false,
        let newRow = {
          'id': null,
          'min_no': 0,
          'max_no': 1,
          'required': true,
          'hide_prices': false,
          'has_default_value': false,
          'active': true,
          'group_company_option_values': []
        }
        this.model.push(newRow)
        this.tabIndex = this.model ? this.model.length - 1 : 0
      },
      addNewOptionValue (optIdx) {
        let newRow = {
          'id': null,
          'active': true,
          'price': 0,
          'pos_id': null
        }
        if (this.use_pos_id_per_product_option) {
          newRow['pos_id_per_product'] = 0
        }
        if (this.use_quantity_per_product_option) {
          newRow['quantity_per_option'] = 0
        }
        this.model[optIdx].group_company_option_values.push(newRow)
      },
      disableOption (optIdx, id, main) {
        // let locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details)
        let thisOptIdx = false
        if (main) {
          if (this.model !== undefined) {
            thisOptIdx = this.getObjectByElemKeyValue('company_option_id', id, this.model)
          }
        } else {
          if (this.model[optIdx] !== undefined) {
            thisOptIdx = this.getObjectByElemKeyValue('company_option_value_id', id, this.model[optIdx]['group_company_option_values'])
          }
        }

        if (thisOptIdx !== false) {
          return true
        } else {
          return false
        }
      },
      changeOption (thisOptIdx, companyOptionId) {
        if (companyOptionId) {
          let companyOptionIndex = this.getObjectByElemKeyValue('id', companyOptionId, this.companyOptions)
          let companyOption = this.companyOptions[companyOptionIndex]
          this.model[thisOptIdx]['group_company_option_values'] = []
          this.model[thisOptIdx]['type'] = companyOption['type']
          this.model[thisOptIdx]['name'] = companyOption['name']
          this.model[thisOptIdx]['company_option_id'] = companyOption['id']
          this.model[thisOptIdx]['required'] = true
          this.model[thisOptIdx]['hide_prices'] = false
          this.model[thisOptIdx]['has_default_value'] = false
          this.tabIndex = thisOptIdx
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      cancelOption () {
        if (this.route.path && this.route.path.includes('/integrations/menu-fix')) {
          window.close()
          return
        }
        // this.router.push('/group-options')
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>
<style scoped lang="scss">
  .prod-tabs .btn.mar-15 {
     margin-top: 25px;
    &:first-of-type {
      margin-top: 15px;
    }
  }
  .group-option-value-select {
    width: 100%;
  }
</style>
<style>
  .copy_link {
    margin-top: 10px;
    width: 100%;
  }
  .upload-demo input[type="file"]{ display: none; }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/GroupOptions/GroupOptionsForm.vue